export const UserLabelConstants = {
    AdminUserManagement: 'Admin User Management',
    AppUserManagement: 'App User Management',
    AppUser: 'App User',
    ListAllBinders: 'List of All Binders',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    CardsList: 'Cards List',
    Pokémon :'Pokémon',
    SyncCards: 'Sync Cards',
    SetsList: 'Sets List',
    SetCardsList: 'Set Cards',
    Dashboard: 'Dashboard',
    VaultXBinderList: 'VaultX Binder List',
    RoleManagement: 'Role Management',
    NotAuthorized: 'Not Authorized',
};

export const LEGAL_WRAPPER_START = `<div style="background-color:#000;color:#fff;padding:16px;margin:-10px">`;
export const LEGAL_WRAPPER_END = `</div>`;

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
export const DefaultImage='assets/images/default-user-profile.svg';
export const APP_USER_OPTIONS = [
    { label: 'Android', value: 'Android' },
    { label: 'iOS', value: 'iOS' },
    { label: 'Inactive since last 7 days', value: 'Inactive' }
  ];
  export const Export_Type='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  export const CARD_VARIANTS = {
    HOLO: {
      name: 'Holo',
      description: 'Holographic variant',
      image: 'assets/images/small-card.png'
    },
    NORMAL: {
      name: 'Normal',
      description: 'Normal variant',
      image: 'assets/images/small-card.png'
    },
    REVERSE: {
      name: 'Reverse Holo',
      description: 'Reverse foil variant',
      image: 'assets/images/collectx-bg.png'
    },
    FIRST_EDITION: {
      name: '1st Edition',
      description: 'First edition print',
      image: 'assets/images/collectx-bg.png'
    },
    W_PROMO: {
      name: 'W Promo',
      description: 'Promotional release',
      image: 'assets/images/collectx-bg.png'
    }
  } as const;
  